const Editor = () => {
  return <section id="Editor"></section>;
};
export default Editor;
